import { Fragment } from "react";

const inline = (text) => {
  const parts = [];
  const re = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g;
  let last = 0;
  let m;
  while ((m = re.exec(text))) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const t = m[0];
    if (t.startsWith("**")) parts.push(<strong key={m.index}>{t.slice(2, -2)}</strong>);
    else {
      const [, label, href] = t.match(/\[([^\]]+)\]\(([^)]+)\)/);
      const ext = /^https?:/.test(href);
      parts.push(<a key={m.index} href={href} className="text-[#147C88] underline underline-offset-2" {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})}>{label}</a>);
    }
    last = m.index + t.length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
};

export function Markdown({ text }) {
  const blocks = [];
  let list = null;
  const flush = () => { if (list) { blocks.push(list); list = null; } };
  text.split("\n").forEach((raw) => {
    const l = raw.trim();
    if (!l) return flush();
    const bullet = l.match(/^([-*]|\d+\.)\s+(.*)/);
    if (bullet) {
      const ordered = /\d/.test(bullet[1]);
      if (!list || list.ordered !== ordered) { flush(); list = { ordered, items: [] }; }
      list.items.push(bullet[2]);
      return undefined;
    }
    flush();
    blocks.push(l);
    return undefined;
  });
  flush();
  return (
    <div className="blog-content flex flex-col gap-4 text-[17px] leading-relaxed text-slate-700" data-testid="blog-content">
      {blocks.map((b, i) => {
        if (typeof b !== "string") {
          const Tag = b.ordered ? "ol" : "ul";
          return <Tag key={i} className={`${b.ordered ? "list-decimal" : "list-disc"} pl-6 flex flex-col gap-1.5`}>{b.items.map((it, j) => <li key={j}>{inline(it)}</li>)}</Tag>;
        }
        if (b.startsWith("### ")) return <h3 key={i} className="mt-4 text-xl font-semibold text-[#0B2A4A]">{inline(b.slice(4))}</h3>;
        if (b.startsWith("## ")) return <h2 key={i} className="mt-8 text-2xl sm:text-3xl font-bold tracking-tight text-[#0B2A4A]">{inline(b.slice(3))}</h2>;
        if (b.startsWith("# ")) return <h2 key={i} className="mt-8 text-2xl font-bold text-[#0B2A4A]">{inline(b.slice(2))}</h2>;
        return <Fragment key={i}><p>{inline(b)}</p></Fragment>;
      })}
    </div>
  );
}
